import { actions } from "Compare/store/actions";
import { state } from "Compare/store/state";
import { mutations } from "Compare/store/mutations";
import { getters } from "Compare/store/getters";

const namespace = "compare";

const store = {
	namespaced: true,
	state,
	actions,
	mutations,
	getters
};

export { namespace, store, actions, getters };